'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { t } from '@lingui/macro';
import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
// import { useSearchUsersByTerm } from '../../hooks/use-search-users-by-term';
import { SearchUsersAutocompleteInput } from './search-users-autocomplete';

const SearchSchema = z.object({
  term: z.string().trim().nullable(),
});

type Props = {
  isPrivate: boolean;
};

type SearchSchemaT = z.infer<typeof SearchSchema>;

export const SearchBar = (props: Props) => {
  const { isPrivate } = props;
  const { control } = useForm<SearchSchemaT>({
    mode: 'all',
    resolver: zodResolver(SearchSchema),
    defaultValues: {
      term: '',
    },
  });

  return (
    <Stack component="form" id="search-term" direction="column" spacing={2}>
      <SearchUsersAutocompleteInput
        control={control}
        name="term"
        label={t`Rechercher un profil`}
        disabled={isPrivate}
      />
    </Stack>
  );
};
